module.exports = __webpack_public_path__ + "static/logo.e90b0785.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 284
// module chunks = 34471704633725 45593596689585